/* eslint-disable no-param-reassign */
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  language: "zh_hant",
};

const settingSlice = createSlice({
  name: "setting",
  initialState,
  reducers: {
    changeLanguage: (state, { payload }) => {
      state.language = payload.language;
    },
  },
});

export const { changeLanguage } = settingSlice.actions;

export default settingSlice.reducer;